import React, { useState } from "react";
import Map from "../components/map/Map.jsx";
import Cell from "../components/Cell.jsx";
import AlertsSwiperCard from "../components/cards/AlertsSwiperCard.jsx";
import PublicContext from "../contexts/PublicContext.jsx";
import SubscribeCard from "../components/cards/SubscribeCard.jsx";
import SensoriDetailsCard from "../components/cards/SensoriDetailsCard.jsx";
import { SensorsMapProvider } from "../contexts/SensorsMapProvider.jsx";
import ReportModal from "../components/modals/ReportModal.jsx";
// import PceCard from "../components/cards/PceCard.jsx";
import RadarCard from "../components/cards/RadarCard.jsx";
import InfoCard from "../components/cards/InfoCard.jsx";

function GridPage() {
	const [showReportModal, setShowReportModal] = useState(false);

	return (
		<PublicContext>
			<SensorsMapProvider>
				<div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-4">
					{/* Mappa */}
					<Cell
						cols={1}
						lgCols={2}
						xlCols={2}
						rows={1}
						xlRows={2}
						style={{ height: "630px" }}
						className="col-span-1 lg:col-span-2 xl:col-span-2 row-span-1 xl:row-span-2 !p-0 "
					>
						<Map />
					</Cell>

					<Cell rows={1} className="lg:h-[370px]">
						<AlertsSwiperCard mode={"allarmeteo"} />
					</Cell>

					<Cell rows={1} className="lg:h-[370px]">
						<AlertsSwiperCard mode={"comune"} />
					</Cell>

					{/* Dettagli Sensori */}
					<Cell rows={1} style={{ height: "245px" }}>
						<SensoriDetailsCard />
					</Cell>

					<Cell rows={1} style={{ height: "245px" }} className=" text-center bg-red-50">
						<h2 className="text-lg font-bold">Invia una Segnalazione</h2>
						<p className="text-gray-800 mt-2">
							Se hai informazioni importanti o vuoi segnalare un problema, fai clic
							sul pulsante qui sotto.
						</p>
						<button
							id="create-report"
							aria-label="Crea Nuova Segnalazione"
							className="mt-4 bg-red-700 text-white px-4 py-2 rounded hover:bg-red-700 transition"
							onClick={() => setShowReportModal(true)}
						>
							Crea Nuova Segnalazione
						</button>
					</Cell>

					{/* Sottoscrizione */}
					<Cell rows={1} className="bg-blue-100">
						<SubscribeCard />
					</Cell>

					{/* Aree di emergenza */}
					<Cell rows={1}>
						<RadarCard />
					</Cell>

					<Cell cols={1} xlCols={2} rows={1}>
						<InfoCard />
					</Cell>
				</div>
			</SensorsMapProvider>
			{showReportModal && <ReportModal onClose={() => setShowReportModal(false)} />}
		</PublicContext>
	);
}

export default GridPage;
